import React from "react";
import TransactionsPage from "components/common/transactions/TransactionsPage";

const EmployeeTransactions: React.FC = () => <TransactionsPage mine />;

export default EmployeeTransactions;
